<template>
<div>
	<div class="app-container app-theme-white body-tabs-shadow">
        <div class="app-container">
            <div class="h-100" id="login-plataforma">
                <router-view></router-view>
            </div>
        </div>
	</div>
</div>
</template>
<script>
export default {
}
</script>